import { ConnectionWizardState, ConnectionWizardActionTypes } from './connectionWizard.types';

const initialState = {
  drawerOpen: false,
  openedAccordionId: 'redisCli',
  bdb: null,
  crdb: null,
  subscription: null,
  connectivityMethod: null,
  regionId: null
} as ConnectionWizardState;

const connectionWizardReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: ConnectionWizardActionTypes
): typeof initialState => {
  switch (action.type) {
    case 'TOGGLE_CONNECTION_WIZARD_DRAWER':
      return {
        ...state,
        drawerOpen: action.payload,
        bdb: !action.payload ? null : state.bdb,
        crdb: !action.payload ? null : state.crdb,
        subscription: !action.payload ? null : state.subscription,
        connectivityMethod: !action.payload ? null : state.connectivityMethod,
        regionId: !action.payload ? null : state.regionId
      };
    case 'SET_OPENED_ACCORDION_ID':
      return {
        ...state,
        openedAccordionId: state.openedAccordionId === action.payload ? null : action.payload
      };
    case 'SET_CONNECTION_WIZARD_BDB':
      return {
        ...state,
        bdb: action.payload
      };
    case 'SET_CONNECTION_WIZARD_CRDB':
      return {
        ...state,
        crdb: action.payload
      };
    case 'SET_CONNECTION_WIZARD_SUBSCRIPTION':
      return {
        ...state,
        subscription: action.payload
      };
    case 'SET_CONNECTION_WIZARD_CONNECTIVITY_METHOD':
      return {
        ...state,
        connectivityMethod: action.payload
      };
    case 'SET_CONNECTION_WIZARD_REGION':
      return {
        ...state,
        regionId: action.payload
      };
    default:
      return state;
  }
};
export default connectionWizardReducer;
